import { render } from "./Booking_ArrivalInfo.vue?vue&type=template&id=48f41b28&scoped=true"
import script from "./Booking_ArrivalInfo.vue?vue&type=script&lang=js"
export * from "./Booking_ArrivalInfo.vue?vue&type=script&lang=js"

import "./Booking_ArrivalInfo.vue?vue&type=style&index=0&id=48f41b28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48f41b28"

export default script